import { Plugin } from '@nuxt/types'
import { VuexPersistence } from 'vuex-persist'

const storeSubscribers: Plugin = ({ $cookies, store }) => {
  new VuexPersistence({
    key: 'sowld-vuex',
    restoreState: key => $cookies.get(key),
    saveState: (key, state) => $cookies.set(key, state),
    modules: ['persistent']
  }).plugin(store)
}

export default storeSubscribers
